import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { LabelPosition } from '@capturum/builders/core';

@Component({
  selector: 'cpb-text-input',
  templateUrl: './text-input.component.html',
})
export class CapturumBuilderTextInputComponent extends FieldType {
  public labelPosition: typeof LabelPosition = LabelPosition;
}
